import styled, { css } from "styled-components"

export default {
    "Wrapper": styled.div`
        display: flex;
        flex-direction: column;
        align-items: center;
        padding: 54px 28px;
        gap: 32px;
    `,

    "RecordList": styled.div`
        display: flex;
        flex-direction: column;
        gap: 16px;
    `,
    "RecordElement": styled.div`
        display: flex;
        align-items: center;
        gap: 8px;
        padding-bottom: 16px;
        border-bottom: 1px solid ${({ theme }) => theme.color["grey2"]};

        & > div {
            display: flex;
            flex-direction: column;
            gap: 4px;

            & > h2 {
                ${({ theme }) => theme.font["large-semibold"]};
                margin-bottom: 4px;
            }

            & > p {
                ${({ theme }) => theme.font["small-regular"]};
            }
        }

        & > p {
            ${({ theme }) => theme.font["small-regular"]};
            white-space: nowrap;
        }
    `,
    "RecordDiv": styled.span`
        display: flex;
        gap: 8px;

        & > h2 {
            ${({ theme }) => theme.font["small-regular"]};
            color: ${({ theme, $inc }) => $inc ? theme.color["error"] : theme.color["grey3"]};
        }

        & > p {
            ${({ theme }) => theme.font["small-semibold"]};
            color: ${({ theme, $inc }) => $inc ? theme.color["error"] : theme.color["grey3"]};
        }
    `,

    "Option": styled.p`
        ${({ theme }) => theme.font["xsmall-medium"]};
    `,
}